import type { MapHome, NestedHome, Database } from "@habity/types";
import { getCategoryText } from "../addresses";
import { ROUTES } from "@habity/constants";
import { generatePreviewToken, PREVIEW_PARAM } from "@habity/utils";
import slugify from 'slugify';

type AddressCategory = Database["public"]["Enums"]["category"];

interface HomePathInput {
  id?: number | null;
  address?: {
    category?: AddressCategory | null;
    rooms?: number | null;
    street?: string | null;
    city?: string | null;
    municipality?: string | null;
  } | null;
  status?: {
    show_address?: boolean | null;
    allow_indexing?: boolean | null;
  } | null;
}

export const getHomeSlug = (home: HomePathInput) => {
  const { address, id, status } = home;
  if (!id) return '';
  const { category, rooms, street, city, municipality } = address || {};
  const { show_address } = status || {};

  // Build slug out of parts
  const categoryPart = category ? getCategoryText(category) : '';
  const roomsPart = rooms ? `-${rooms}rum` : '';
  const streetPart = street && show_address ? `-${street}` : ''
  const cityPart = city ? `-${city}` : '';
  const municipalityPart = municipality ? `-${municipality}-kommun` : '';

  return slugify(
    `${categoryPart}${roomsPart}${streetPart}${cityPart}${municipalityPart}-${id}`
  );
};

export const getHomePath = (home: HomePathInput, includePreviewToken = true) => {
  const basePath = ROUTES.PROFILES.HOMES + getHomeSlug(home);
  if (includePreviewToken && home.id && home.status?.allow_indexing === false) {
    return `${basePath}?${PREVIEW_PARAM}=${generatePreviewToken(home.id)}`;
  }
  return basePath;
};

export const getHomeEditPath = (home: NestedHome) =>
  ROUTES.DASHBOARD.HOMES.EDIT_PATH + '/' + home.id;

export const getHomeClaimPath = (addressId: number) =>
  ROUTES.CLAIM + '/' + addressId;

export const getHomeBuyersPath = (addressId: number) =>
  ROUTES.SEARCH_BUYERS_PATH + addressId + '?tab=buyers';

export const getHomeBuyersDashboardRoute = (homeId: number) => {
  return ROUTES.DASHBOARD.HOMES.VIEW_BUYERS_PATH + homeId;
};
